export default __webpack_public_path__ + "static/media/1880.30a89904.png";